<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="10">
                    <input type="text" v-model="searchMenu" placeholder="Nama Menu" class="form-control"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="4"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="moving()" type="button" class="btn btn-add">Tambah</CButton>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    </div>
    <div v-else class="area-edit">
        <CModal
            size="sm"
            :centered="true"
            title="Info Delete"
            color="danger"
            :show.sync="deleteModal"
            >
            <p>Apakah anda yakin ingin menghapus menu {{nama}}?</p>
            <CRow>
                <CCol sm="6">
                    <CButton @click="deleteModal = false" class="btn btn-secondary w-100 text-center btn-cancel">Batal</CButton>
                </CCol>
                <CCol sm="6">
                    <CButton @click="goSave('D')" class="btn btn-danger w-100 text-center btn-delete">Ya, Hapus</CButton>
                </CCol>
            </CRow>
            <template #footer-wrapper><span></span></template>
        </CModal>
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="6">
                        <label>ID Menu</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.id.$model"
                            :class="{ 'is-invalid':$v.id.$error, 'is-valid': !$v.id.$invalid }"
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" 
                            placeholder="ID Menu"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Nama Menu</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.nama.$model"
                            :class="{ 'is-invalid':$v.nama.$error, 'is-valid': !$v.nama.$invalid }"
                            placeholder="Nama Menu"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Deskripsi</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.deskripsi.$model"
                            :class="{ 'is-invalid':$v.deskripsi.$error, 'is-valid': !$v.deskripsi.$invalid }"
                            placeholder="Deskripsi"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow class="mt-2 mb-5">
                    <CCol sm="6">
                        <label>Signature (.jpg, .png) *Maks 2MB</label>
                        <div v-if="urlImage == '' || urlImage == 'null'">
                            <input v-on:change="onFileChange" style="position:absolute;opacity:0;z-index:1;cursor:pointer" type="file" class="mr-2" accept=".jpg, .png, .bmp" />
                            <div :class="classSignature">+</div>
                        </div>
                        <div v-else>
                            <img :src="urlImage" width="56" height="56" />
                            <button @click="removeImage()" class="ml-3 btn btn-danger" size="sm">Delete</button>
                        </div>
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow class="area-button-submit">
            <CCol sm="12">
                <CButton @click="moving()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
                <CButton v-if="tipe != 'C'" @click="deleteModal = true" class="btn btn-edit-delete mr-2">
                    <span>Delete</span>
                </CButton>
                <CButton @click="submitForm()" class="btn btn-edit-submit">
                    <span v-if="loading == false">Submit</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
import Tables from '../../../component/tableRoleMenu'
import { DataApi, DataApiUpload } from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
export default {
    components: {
        Tables,
        ModelSelect
    },
    mixins: [validationMixin],
    validations: {
        id: {
            required
        },
        nama: {
            required
        },
        deskripsi: {
            required
        },
    },
    data() {
        return {
            success: true,
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            dataTh: ['ID', 'Nama Menu', 'Deskripsi', 'Logo', 'Action'],
            dataTd: ['id', 'nama', 'deskripsi', 'urlLogo', 'action'],
            styleTable: ['50px', '200px', '300px', '100px', '100px'],
            classReload: 'reloadOff',
            goArea: true,
            loading: false,
            alertMess: '',
            currentAlertCounter: 0,

            // data model
            unix: '',
            id: '',
            nama: '',
            deskripsi: '',
            tipe: 'C',
            

            // pagination
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter
            searchMenu: '',
            
            
            // datas
            datas: [],

            //error
            errorMessage: '',
            deleteModal: false,
            urlImage: '',
            showImage: '',
            urlPath: '',

            lvl: '',
            organisasi: '',
            classSignature: 'cards-image',
            flagSearch: false
        }
    },
    computed: {
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        searchMenu() {
            this.flagSearch = true
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        }
    },
    methods: {
            /**
         * GET DATA
         */
        /**
         * SEARCH PERUSAHAAN
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.namaMenu.toLowerCase() < b.namaMenu.toLowerCase()) {
                        return -1
                    }
                    if (a.namaMenu.toLowerCase() > b.namaMenu.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.pathMenu.toLowerCase() < b.pathMenu.toLowerCase()) {
                        return -1
                    }
                    if (a.pathMenu.toLowerCase() > b.pathMenu.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.urutan < b.urutan) {
                        return -1
                    }
                    if (a.urutan > b.urutan) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 3) {
                function compare(a,b) {
                    if (a.idParent.toLowerCase() < b.idParent.toLowerCase()) {
                        return -1
                    }
                    if (a.idParent.toLowerCase() > b.idParent.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 4) {
                function compare(a,b) {
                    if (a.deskripsi.toLowerCase() < b.deskripsi.toLowerCase()) {
                        return -1
                    }
                    if (a.deskripsi.toLowerCase() > b.deskripsi.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let limit = this.size
            let page = this.page
            let namaMenu = this.searchMenu

            let payload = {
                limit: limit,
                pageIn: page,
                filter: namaMenu,
            }
            DataApi.post("menu/mobile/get", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        reload() {
            this.searchMenu = ''
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },

        /**
         * ADD DATA
         */
        moving() {
            setTimeout(this.moveArea, 600);
        },
        moveArea() {
            if(this.goArea == true) {
                this.goArea = false
            } else {
                this.goArea = true
                this.unix = ''
                this.id = ''
                this.nama = ''
                this.deskripsi = ''
                this.urlImage = ''
                this.showImage = ''
                this.urlPath = ''
                this.classSignature = 'cards-image'
                this.tipe = 'C'
                this.$v.$reset()
            }
        },
        goSave(param) {
            let tipe = ''
            if(param == 'null') {
                tipe = this.tipe
            } else {
                tipe = 'D'
            }
            let payload = {
                deskripsi: this.deskripsi,
                id: this.id,
                nama: this.nama,
                tipe: tipe,
                unix: this.unix,
                urlLogo: this.urlPath
            }
            DataApi.post("menu/mobile/save", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.deleteModal = false
                this.getData()
                this.moving()
                this.loading = false
                this.currentAlertCounter = 7
            })
        },

        /**
         * EDIT DATA
         */
        editData(value) {
            let generate = this.datas[value]
            this.tipe = 'u'
            this.id = generate.id
            this.nama = generate.nama
            this.deskripsi = generate.deskripsi
            this.unix = generate.unix
            this.urlImage = generate.urlLogo
            this.classSignature = 'cards-image'
            this.moving()
        },

        /**
         * Validation
         */
        submitForm() {
            this.$v.$touch()
            if(this.$v.$invalid) {
                if(this.urlImage == '') {
                    this.classSignature = 'err-sig'
                }
            } else {
                if(this.urlImage == '') {
                    this.classSignature = 'err-sig'
                } else {
                    this.classSignature = 'cards-image'
                    this.saveImage()
                    this.loading = true
                }
            }
        },

        
        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.showImage = files[0];
            this.createImage(files[0]);
        },
        createImage(file) {
            let reader = new FileReader();
            reader.onload = (e) => {
                this.urlImage = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        saveImage() {
            if (this.urlImage.split(":")[0] == 'data' && this.urlImage != '') {
                let imageData = this.showImage
                let idPegawaiData = 0
                let inOutData = "1"
                let kodePerusahaanData = this.organisasi
                let tanggalData = new Date()
                let lvlData = this.lvl

                const fd = new FormData()
                fd.append('file', imageData)
                fd.append('idPegawai', idPegawaiData)
                fd.append('inOut', inOutData)
                fd.append('kodePerusahaan', kodePerusahaanData)
                fd.append('tanggal', tanggalData)
                fd.append('lvl', lvlData)

                DataApiUpload.post('upload/file', fd)
                .then(res => {
                    let response = res.data
                    if(response.success == true) {
                        this.urlPath = response.data.urlPath
                        this.goSave('null')
                    } else {
                        alert('Upload Photo Failed !')
                        this.loading = false
                    }
                });
            } else if(this.urlImage == '') {
                this.urlPath = ''
                this.goSave('null')
            } else {
                this.urlPath = this.urlImage
                this.goSave('null')
            }
        },
        removeImage() {
            this.showImage = ''
            this.urlImage = ''
            this.urlPath = ''
        },
        getDataToken() {
            DataApi.get("pegawai/role/cek")
            .then( response => {
                let res = response.data
                if(res.success == true) {
                    this.lvl = res.data.lvl
                    this.organisasi = res.data.organisasi
                    this.getData()
                }
            })
        }
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataToken()
    },
}
</script>
<style scoped>
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
@media screen and (min-width: 1253px) and (max-width: 1358px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1168px) and (max-width: 1252px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1097px) and (max-width: 1167px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1036px) and (max-width: 1096px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 992px) and (max-width: 1035px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1359px){
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}
.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select, .area-input .autocomplete {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 32px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}


.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 32px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 40px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: scroll;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.btn-edit-delete {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:red;
    color: white;
    font-size: 14px;
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
.err-sig {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted red;
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
</style>